import $ from 'jquery';

document.addEventListener('DOMContentLoaded', init, false);

function init(){
  adsBlocked(function(blocked) {
    if (blocked) {
      const popupAdblock = document.getElementById('popup-adblock');
      if (popupAdblock) {
        popupAdblock.classList.add('show');
      }
      $('#popup-adblock .popup__close, #popup-adblock .btn-holder a').on('click', function () {
        $('#popup-adblock').removeClass('show');
      });
    }
  });
}
function adsBlocked(callback){
  const testURL = 'https://googleads.g.doubleclick.net/pagead/id';

  const myInit = {
    method: 'HEAD',
    mode: 'no-cors'
  };

  const myRequest = new Request(testURL, myInit);

  fetch(myRequest).then(function(response) {
    return response;
  }).then(function(response) {
    callback(false);
  }).catch(function(e) {
    callback(true);
  });
}
